import styled from "styled-components";

export const Container = styled.div`
    min-height: calc(100vh - 80px);
    display: flex;
    padding: 0.5rem calc((100vw - 1000px) / 2);
    background-color: #0093E9;
    background-image: linear-gradient(0deg, #0093E9 0%, #99d4f7 50%, #ffffff 100%);
`;